<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span @click="goBack">Settings</span>
                    <a>User Config</a>
                </div>
            </div>
            <div class="start-overflow">
                <div class="create-company-container w-100 ">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center px-10 justify-content-between">
                            <span class="fs-14 text-white ml-3">User Permission</span>
                            <!-- <span class="pointer mt-2">
                                <i class="icon-chevron-double-down text-white" style="font-size: 20px;"></i>
                            </span> -->
                            <!-- <div class="d-flex">
                                <button class="btn btn-success text-capitalize text-white btn-sm">Save</button>
                                <button class="btn ml-3 btn-white text-capitalize text-secondary btn-sm">Discard</button>
                            </div> -->
                        </div>
                        <!-- User Role Section -->
                        <div class="row px-10">
                            <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                                <span class="fs-14 fw-600 px-4 text-secondary">User Role</span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                            name="user_role" @select="loadUserPermissions" :loading="users_loading" @search-change="searchUserRoles" :searchable="true" label="name" v-model="selected_user_role" :max-height="200"
                                            v-validate="'required'" :options="user_role_options"
                                            placeholder="Select User Role">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">User Role not Found</div>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfUsers" />
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('user_role')">
                                    User Role is Required
                                </span>
                            </div>
                        </div>
                        <div class="px-10 pt-5">
                            <div class="overflow-auto">
                                <!-- Table Section -->
                                <table>
                                    <tr class="bg-color">
                                        <th class="text-uppercase text-nowrap">Module</th>
                                        <th class="text-uppercase text-nowrap">Sub Module</th>
                                        <th class="text-uppercase text-nowrap">View</th>
                                        <th class="text-uppercase text-nowrap">Create</th>
                                        <th class="text-uppercase text-nowrap">Edit</th>
                                        <th class="text-uppercase text-nowrap">Delete</th>
                                        <th class="text-uppercase text-nowrap">Archive</th>
                                        <th class="text-uppercase text-nowrap">Retrieve</th>
                                        <th class="text-uppercase text-nowrap">Lead Conversion</th>
                                        <th class="text-uppercase text-nowrap">Qualifying Leads</th>
                                        <th class="text-uppercase text-nowrap">Closed Deals</th>
                                        <th class="text-uppercase text-nowrap">Clone</th>
                                        <th class="text-uppercase text-nowrap">Send</th>
                                        <th class="text-uppercase text-nowrap">Approval</th>
                                    </tr>
                                    <tr class="w-100" v-if="ajaxCallinprogress && modules.length">
                                        <td colspan="15">
                                            <div class="d-flex align-items-center justify-content-center w-100">
                                                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="!ajaxCallinprogress && modules.length == 0" class="text-center font-weight-bold">
                                        <td colspan="15">No Contacts Found</td>
                                    </tr>
                                    <template v-for="(mod,index) in module_permissions">
                                        <tr :key="index">
                                            <td>
                                                <div class="table-content-left-end">
                                                    <div class="h-25">
                                                        <span class="text-nowrap text-capitalize">
                                                            {{mod.module.replace('_',' ') || '-'}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between">
                                                    <div class="h-25">
                                                        <span class="text-nowrap text-capitalize">{{mod.sub_module.replace('_',' ') || '-'}}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('view')">
                                                            <el-checkbox  v-model="mod.permitted_actions.view" :checked="mod.permitted_actions.view == true" class="checkbox-inverse" @change="updatePermission(mod)"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('create')">
                                                            <el-checkbox v-model="mod.permitted_actions.create" :checked="mod.permitted_actions.create == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('edit')">
                                                            <el-checkbox v-model="mod.permitted_actions.edit" :checked="mod.permitted_actions.edit == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('delete')">
                                                            <el-checkbox v-model="mod.permitted_actions.delete" :checked="mod.permitted_actions.delete == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('archive')">
                                                            <el-checkbox v-model="mod.permitted_actions.archive" :checked="mod.permitted_actions.archive == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('retrieve')">
                                                            <el-checkbox v-model="mod.permitted_actions.retrieve" :checked="mod.permitted_actions.retrieve == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('convert')">
                                                            <el-checkbox v-model="mod.permitted_actions.convert" :checked="mod.permitted_actions.convert == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('qualify')">
                                                            <el-checkbox v-model="mod.permitted_actions.qualify" :checked="mod.permitted_actions.qualify == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('closed_deal')">
                                                            <el-checkbox v-model="mod.permitted_actions.closed_deal" :checked="mod.permitted_actions.closed_deal == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('clone')">
                                                            <el-checkbox v-model="mod.permitted_actions.clone" :checked="mod.permitted_actions.clone == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-between checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('send')">
                                                            <el-checkbox v-model="mod.permitted_actions.send" :checked="mod.permitted_actions.send == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-content-right-end checkbox-cell">
                                                    <div class="h-25">
                                                        <span v-show="mod.actions.includes('approval')">
                                                            <el-checkbox v-model="mod.permitted_actions.approval" :checked="mod.permitted_actions.approval == true" @change="updatePermission(mod)" class="checkbox-inverse"></el-checkbox>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
    import { SweetModal } from 'sweet-modal-vue';
    import { HalfCircleSpinner } from "epic-spinners";
    import user_permission from "../mixins/user_permission.js";
    import { debounce } from 'lodash';
    export default {
        data() {
            return {
                selected_user_role: null,
                user_role_options: [],
                modules: [],
                module_permissions: [],
                ajaxCallinprogress: false,
                //user roles,
                users_loading: false,
                temp_users: [],
                users_count: 0,
                users_scrollable: false,
                users_visible: false,
                fetch_permissions: [],
                success_msg: "",
                warning_msg: ""
            }
        },
        components:{
            SweetModal,
            HalfCircleSpinner
        },
        mixins:[user_permission],
        methods:{
            goBack() {
                this.$router.push('/settingComponents')
            },
            async updatePermission(mod){
                setTimeout(async () => {
                    let actions = []
                    if(mod.permitted_actions.create){
                        actions.push('create')
                    }
                    if(mod.permitted_actions.edit){
                        actions.push('edit')
                    }
                    if(mod.permitted_actions.delete){
                        actions.push('delete')
                    }
                    if(mod.permitted_actions.view){
                        actions.push('view')
                    }
                    if(mod.permitted_actions.archive){
                        actions.push('archive')
                    }
                    if(mod.permitted_actions.retrieve){
                        actions.push('retrieve')
                    }
                    if(mod.permitted_actions.clone){
                        actions.push('clone')
                    }
                    if(mod.permitted_actions.send){
                        actions.push('send')
                    }
                    if(mod.permitted_actions.qualify){
                        actions.push('qualify')
                    }
                    if(mod.permitted_actions.convert){
                        actions.push('convert')
                    }
                    if(mod.permitted_actions.approval){
                        actions.push('approval')
                    }
                    let params = {
                        permissions: [{
                            id: mod.id,
                            module: mod.module,
                            sub_module: mod.sub_module,
                            permitted_actions: actions
                        }]
                    }
                    let response = await this.editUserPermissions(this.selected_user_role.value,params)
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.loadUserPermissions(this.selected_user_role);
                    }, 2000);
                    this.$forceUpdate()
                }, 500);
            },
            async getUserPermissionData() {
                this.ajaxCallinprogress = true;
                let response = await this.getUserPermittedCheckbox();
                this.module_permissions = response.response
                this.fetch_permissions.forEach(y => {
                    this.module_permissions.forEach(x => {
                        if((x.sub_module == y.sub_module) && (x.module == y.module)){
                            x['id'] = y.id
                            x['permitted_actions'] = {
                                create: y.permitted_actions.includes('create') ? y.actions.create : false,
                                delete: y.permitted_actions.includes('delete') ? y.actions.delete : false,
                                edit: y.permitted_actions.includes('edit') ? y.actions.edit : false,
                                view: y.permitted_actions.includes('view') ? y.actions.view : false,
                                archive: y.permitted_actions.includes('archive') ? y.actions.archive : false,
                                retrieve: y.permitted_actions.includes('retrieve') ? y.actions.retrieve : false,
                                convert: y.permitted_actions.includes('convert') ? y.actions.convert : false,
                                qualify: y.permitted_actions.includes('qualify') ? y.actions.qualify : false,
                                closed_deal: y.permitted_actions.includes('closed_deal') ? y.actions.closed_deal : false,
                                clone: y.permitted_actions.includes('clone') ? y.actions.clone : false,
                                send: y.permitted_actions.includes('send') ? y.actions.send : false,
                                approval: y.permitted_actions.includes('approval') ? y.actions.approval : false
                            }
                        }
                    })
                })
                let permissions = {}
                this.module_permissions.forEach(x => {
                    if(x.module == 'contacts' && x.sub_module == 'business'){
                        permissions['contacts_business'] = x
                    }
                    else if(x.module == 'contacts' && x.sub_module == 'personal'){
                        permissions['contacts_personal'] = x
                    }
                    else if(x.module == 'company_profile'){
                        permissions['company_profile'] = x
                    }
                    else if(x.module == 'products'){
                        permissions['products'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'campaigns'){
                        permissions['campaigns'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'customers'){
                        permissions['customers'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'deals'){
                        permissions['deals'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'leads'){
                        permissions['leads'] = x
                    }
                    else if(x.module == 'sales' && x.sub_module == 'sales_forecast'){
                        permissions['sales_forecast'] = x
                    }
                    else if(x.module == 'settings'){
                        permissions['settings'] = x
                    }
                    else if(x.module == 'survey_forms'){
                        permissions['survey_forms'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'call_reports'){
                        permissions['call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'draft_call_reports'){
                        permissions['draft_call_reports'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'reminders'){
                        permissions['reminders'] = x
                    }
                    else if(x.module == 'tools' && x.sub_module == 'teams'){
                        permissions['teams'] = x
                    }
                })
                this.$store.commit("setUserPermissions",permissions)
                this.ajaxCallinprogress = false
                this.$forceUpdate();
            },
            async searchUserRolesDebouncer(user) {
                this.users_loading = true
                let params = {
                    search_key: user,
                    product_id: this.loggedInUser.product_id
                }
                let response = await this.getUserRoles(params)
                this.user_role_options = response.response
                this.users_count = this.user_role_options.length
                this.users_loading = false
                this.users_scrollable = false
            },
            async loadUserRoles() {
                // this.ajaxCallinprogress = true;
                let params = {
                    skip: 0,
                    limit: 10,
                    product_id: this.loggedInUser.product_id
                }
                let response = await this.getUserRoles(params)
                this.user_role_options = response.response
                this.users_count = this.user_role_options.length
                this.user_role_options.forEach(x => {
                    if(x.value == this.loggedInUser.user_role){
                        this.selected_user_role = x
                    }
                })
                this.loadUserPermissions(this.selected_user_role)
                // this.ajaxCallinprogress = false;
                this.users_scrollable = false
            },
            async reachedEndOfUsers(reached) {
                this.users_visible = reached
                if (reached) {
                    if (this.users_scrollable == false) {
                        this.users_loading = true
                        let response = await this.getUserRoles({
                            skip: this.users_count,
                            limit: 10,
                            product_id: this.loggedInUser.product_id
                        })
                        this.temp_users = response.response.length;
                        if (response.skip == this.users_count) {
                            if (this.temp_users > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.user_role_options.push(el);
                                });
                                this.user_role_options = this.user_role_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.user_role_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.users_count += response.response.length;
                                this.users_loading = false
                            } else {
                                this.users_scrollable = true
                                this.users_loading = false
                            }
                        }
                        this.users_loading = false
                    }
                }
            },
            async loadUserPermissions(selected_user_role){
                let response = await this.getUserPermissionsSalesManager(selected_user_role.value)
                this.fetch_permissions = response.response.permissions
                this.getUserPermissionData()
                this.$forceUpdate();
            },
            async loadModules(){
                // this.ajaxCallinprogress = true;
                let response = await this.getUserPermissionsModules('both','')
                this.modules = response.response.modules
                this.loadUserRoles()
                this.getUserPermissionData()
            }
        },
        mounted(){
            this.ajaxCallinprogress = true;
            this.loadModules()
        },
        created(){
            this.searchUserRoles = debounce(this.searchUserRolesDebouncer, 500)
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        }
    }
</script>

<style scoped>
    table {
        width: 100% !important;
    }

    .h-25 {
        height: 20px !important;
    }

    table th {
        padding: 10px !important;
    }

    table td {
        padding: 10px 0px !important;
    }

    .display-none{
        display:none;
    }

    /* table td div span{
        height: 60px;
    } */
    .table-content-left-end {
        border-top: 1px solid #00448b;
        padding: 8px 10px;
        border-bottom: 1px solid #00448b;
        border-left: 1px solid #00448b;
        border-radius: 5px 0px 0px 5px;
    }

    .table-content-right-end {
        border-top: 1px solid #00448b;
        padding: 8px 10px;
        border-bottom: 1px solid #00448b;
        border-right: 1px solid #00448b;
        border-radius: 0px 5px 5px 0px;
    }

    .table-content-between {
        border-top: 1px solid #00448b;
        padding: 8px 10px;
        border-bottom: 1px solid #00448b;
    }

    .checkbox-cell {
        padding: 8px 10px !important;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .overflow-auto {
        overflow: auto !important;
    }

    .bg-color {
        background-color: #cce3fc;
        color: #504f4f !important;
        padding: left 0px !important;
    }

    .visibility-hidden {
        visibility: hidden !important;
    }

    /* .checkbox-inverse */
</style>


// WEBPACK FOOTER //
// src/components/SettingsComponents/UserPermission.vue